import { Store } from "redux";
import { settings } from "../../../../settings/settings-util";
import { AlmeState } from "../../../../wireup/AlmeState";
import { DataCollectionPane } from "../renderers/DataCollectionPane";

export class FocusHook {
    dataCollectionPane: DataCollectionPane;
    store: Store<AlmeState> | null = null;

    constructor(dataCollectionPane: DataCollectionPane) {
        this.dataCollectionPane = dataCollectionPane;
        this.store = this.dataCollectionPane._store;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hook(_overlayFormBody: HTMLDivElement, _propertyName: string, _previousValue: FocusHook): void {
        if (this.shouldFocusForm()) {
            const overlayFormElement = _overlayFormBody.querySelector(`input,select`) as HTMLElement;
            overlayFormElement?.focus();
        }
    }

    shouldFocusForm(): boolean {
        const { Base, shouldFocus } = settings.stateLocations.History;
        const shouldFocusForm = this.store?.getState()[Base][shouldFocus] as boolean;
        return shouldFocusForm;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/utilities/FocusHook.ts